import ApplicationController from '../application_controller'
import { get_csrf_token } from '../../app/csrf_token.js'

export default class extends ApplicationController {

	static targets = [
		'sessionTemplateSelect',
		'viewTemplateButton',
		'editTemplateButton',
		'activityContainer',
		'activityContainerEmptyMessage',
	]

	static values = {
		sessionTemplateSelectedPath: String,
	}

	connect() {
		this.updateActivityContainer({ sessionId: this.sessionTemplateSelectTarget.value })
	}

	changeSessionTemplate(event) {
		if (this.sessionTemplateSelectTarget.value) {
			const sessionTemplateId = this.sessionTemplateSelectTarget.value
			this.updateActivityContainer({ sessionId: sessionTemplateId })
			this.enableTemplateButtons(sessionTemplateId)
		} else {
			this.updateActivityContainer({ sessionId: "" })
			this.disableTemplateButtons()
		}
	}

	updateActivityContainer(sessionTemplateAttributes) {
		const params = { authenticity_token: get_csrf_token() }

		fetch(`/programs/select_session_template/${sessionTemplateAttributes.sessionId}`, {
			method: 'POST',
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(params)
		})
			.then(response => response.text())
			.then(html => Turbo.renderStreamMessage(html))
	}

	enableTemplateButtons(sessionTemplateId) {
		this.viewTemplateButtonTarget.href = `/session_templates/${sessionTemplateId}`
		this.viewTemplateButtonTarget.classList.remove('disabled')
		this.editTemplateButtonTarget.href = `/session_templates/${sessionTemplateId}/edit?redirect_to=${window.location.href}`
		this.editTemplateButtonTarget.classList.remove('disabled')
	}

	disableTemplateButtons() {
		this.viewTemplateButtonTarget.href = '#'
		this.viewTemplateButtonTarget.classList.add('disabled')
		this.editTemplateButtonTarget.href = '#'
		this.editTemplateButtonTarget.classList.add('disabled')
	}
}
